module.exports = __webpack_public_path__ + "static/media/grass_fed_beef_mobile.4eac4741.mp4";